export default {
  title: 'Histórico de edição do menu',
  subtitle: 'Veja quem alterou preços, disponibilidade e visibilidade em {{company}} — e quando.',
  filters: {
    type: {
      label: 'Tipo',
    },
    item: {
      placeholder: 'Todos os itens',
    },
    event: {
      label: 'Evento',
    },
  },
  columns: {
    when: 'Quando',
    who: 'Alterado por',
    type: 'Tipo',
    item: 'Item',
    event: 'Evento',
    changes: 'Alterações',
  },
  types: {
    product: 'Produto',
    modifier: 'Modificador',
    category: 'Categoria',
    modifier_group: 'Grupo de modificadores',
    menu: 'Menu',
  },
  events: {
    created: 'Criado',
    updated: 'Atualizado',
    deleted: 'Eliminado',
  },
  fields: {
    name: 'Nome',
    description: 'Descrição',
    price: 'Preço',
    is_available: 'Disponibilidade',
    is_visible: 'Visibilidade',
    is_available_for_pickup: 'Disponibilidade para recolha',
    is_available_for_delivery: 'Disponibilidade para entrega',
    tax_category_id: 'Categoria de imposto',
    schedule: 'Horário de apresentação',
    is_required: 'Obrigatório',
    max_count: 'Máximo de escolhas',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Preço para recolha',
    delivery: 'Preço de entrega',
    dine_in: 'Preço no local',
    room_service: 'Preço de serviço de quarto',
  },
  booleans: {
    on: 'Disponível',
    off: 'Indisponível',
    yes: 'Sim',
    no: 'Não',
  },
  schedule: {
    always: 'Sempre',
    every_day: 'Todos os dias',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Seguinte',
  },
  causers: {
    undo: 'Anular',
    orders_terminal: 'Terminal de pedidos',
    approved_by: {
      amigo: 'Amigo, aprovado por {{name}}',
      assistant: 'Assistente, aprovado por {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Abrir no registo do Amigo',
  system: 'Sistema',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Falha ao carregar o histórico de edição do menu',
  },
};
